import lauraImage from "@/assets/laura.webp";
import { Heart, Feather, HandHeart, Bird } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";

const points = [
  {
    icon: Heart,
    text: "Significa essere accolti, ascoltati, presi per mano, accompagnati e sostenuti in un viaggio all'interno del nostro IO più profondo.",
  },
  {
    icon: Feather,
    text: "Significa accogliere ciò che emerge, lasciando fluire ogni emozione, qualsiasi essa sia.",
  },
  {
    icon: HandHeart,
    text: "Significa stabilire pian piano un rapporto di fiducia con l'operatore e sentire nelle sue mani un linguaggio fatto di quella dolcezza che tocca l'anima, che rassicura, come a dire: “io sono qui con te”.",
  },
  {
    icon: Bird,
    text: "È sentirsi amati, di quell'amore puro e innocente con cui si può amare ogni essere vivente.",
  },
];

const Studio = () => {
  return (
    <section id="studio" className="py-24 bg-gradient-to-b from-background to-secondary/30">
      <div className="container mx-auto px-4">
        {/* Intestazione */}
        <Reveal className="text-center max-w-3xl mx-auto mb-16">
          <p className="eyebrow">Lo Studio</p>
          <h2 className="mt-3 font-serif text-4xl md:text-6xl text-primary">
            Scienze antiche, benessere su misura
          </h2>
          <p className="mt-5 text-lg md:text-xl text-foreground/80 leading-relaxed">
            Due discipline millenarie, l'Ayurveda e la medicina tradizionale cinese,
            unite in un percorso naturale e su misura per l'equilibrio di mente, corpo
            e spirito.
          </p>
          <p className="mt-3 text-sm text-muted-foreground">
            Operatore olistico disciplinato ai sensi della legge 14 gennaio 2013, n. 4
            (G.U. 26 gennaio 2013, n. 22)
          </p>
        </Reveal>

        {/* Laura + Chi sono */}
        <div className="grid md:grid-cols-5 gap-10 items-center max-w-5xl mx-auto mb-24">
          <Reveal className="md:col-span-2 flex flex-col items-center text-center">
            <div className="relative">
              <div className="absolute -inset-3 rounded-full bg-accent/20 blur-lg" />
              <img
                src={lauraImage}
                alt="Laura - Operatrice Olistica"
                className="relative w-60 h-60 object-cover rounded-full shadow-xl ring-4 ring-card"
              />
            </div>
            <h3 className="mt-6 font-serif text-3xl text-primary">Laura</h3>
            <p className="text-muted-foreground">Operatrice Olistica</p>
          </Reveal>

          <Reveal className="md:col-span-3 bg-card p-8 md:p-10 rounded-3xl shadow-lg border border-border">
            <h4 className="font-serif text-2xl md:text-3xl text-primary mb-4">Chi sono</h4>
            <p className="mb-4 text-foreground/90 leading-relaxed">
              Mi chiamo Laura e sono un'operatrice olistica specializzata in trattamenti
              ayurvedici e in riflessologia plantare. La mia passione per il benessere
              olistico e l'ayurveda mi ha portato a creare ORIGINI, uno spazio dove le
              persone possono ritrovare il proprio equilibrio attraverso trattamenti
              naturali e personalizzati.
            </p>
            <p className="text-foreground/90 leading-relaxed">
              Il mio approccio si basa sulla profonda convinzione che ogni persona sia
              unica e che il vero benessere nasca dall'armonia tra corpo, mente e spirito.
            </p>
            <Link
              to="/laura"
              className="mt-5 inline-flex items-center font-medium text-accent hover:text-primary transition-colors"
            >
              Scopri la mia storia →
            </Link>
          </Reveal>
        </div>

        {/* Filosofia */}
        <Reveal className="max-w-4xl mx-auto text-center">
          <p className="eyebrow">La salute nelle medicine antiche</p>
          <blockquote className="mt-4 font-serif text-3xl md:text-5xl text-primary leading-tight">
            Ricevere un trattamento non è solo “tecnica”.
            <span className="italic text-accent"> È amore.</span>
          </blockquote>
          <p className="mt-6 text-foreground/80 leading-relaxed">
            I benefici sul fisico sono davvero molteplici, ma ciò che accomuna queste
            discipline — dall'Ayurveda alla medicina tradizionale cinese — è qualcosa di
            più sottile.
          </p>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto mt-12">
          {points.map(({ icon: Icon, text }, i) => (
            <Reveal
              key={i}
              className="flex gap-4 items-start bg-card p-6 rounded-2xl border border-border"
            >
              <span className="flex-shrink-0 w-11 h-11 rounded-full bg-accent/15 flex items-center justify-center">
                <Icon className="w-5 h-5 text-accent" />
              </span>
              <p className="text-foreground/90 leading-relaxed">{text}</p>
            </Reveal>
          ))}
        </div>

        <div className="text-center mt-14">
          <Button asChild size="lg" className="text-base px-8 py-6 rounded-full">
            <Link to="/trattamenti">Scopri tutti i trattamenti</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Studio;
